import React from "react";
import { createPortal } from "react-dom";
import { ReactComponent as DeleteSvg } from "../svgs/delete.svg";
import { ReactComponent as CloseSvg } from "../svgs/close.svg";
import { FullscreenModal } from "./FullscreenModal";
import { Header } from "./Header";
import {
  WarehouseButtonsFooter,
  WarehouseButton,
} from "./WarehouseButtonsFooter";

export const PhotoThumbnailsModal = ({
  isOpen,
  onClose,
  photos,
  onDeletePhoto,
  title,
}) => {
  if (!isOpen) return null;

  return createPortal(
    <>
      <style>{`
        @keyframes photoFadeIn {
          from {
            opacity: 0;
            transform: scale(0.9) translateY(10px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
      `}</style>
      <FullscreenModal>
        <div className="flex flex-col h-full bg-black/95">
          <Header opacity="100%">
            <div className="flex justify-between items-center w-full">
              <span className="font-bold text-2xl text-white">{title}</span>
              <button
                onClick={onClose}
                className="p-2 hover:bg-white/10 rounded-lg transition-colors"
              >
                <CloseSvg className="w-6 h-6 fill-white" />
              </button>
            </div>
          </Header>

          <div className="flex-1 flex items-center justify-center p-8 overflow-auto">
            <div className="flex flex-wrap justify-center items-center gap-8 max-w-[1600px]">
              {photos.map((image, index) => (
                <div
                  key={index}
                  className="relative group"
                  style={{
                    animation: `photoFadeIn 0.4s ease-out ${index * 0.08}s both`,
                  }}
                >
                  <div className="relative overflow-hidden rounded-2xl shadow-2xl transition-all duration-300 hover:scale-105 hover:shadow-3xl">
                    <img
                      src={image}
                      alt={`Captured ${index + 1}`}
                      className="w-80 h-60 object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </div>
                  <button
                    onClick={() => onDeletePhoto(image)}
                    className="absolute -top-3 -right-3 p-0.5 bg-red-600 rounded-full shadow-xl hover:bg-red-700 transform transition-all duration-200 hover:scale-110 ring-2 ring-red-600"
                  >
                    <DeleteSvg
                      className="w-8 h-8 fill-white"
                      alt="Delete image"
                    />
                  </button>
                  <div className="absolute bottom-3 left-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="text-white text-base font-semibold bg-black/60 px-3 py-1.5 rounded-lg backdrop-blur-sm">
                      Photo {index + 1}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {photos.length === 0 && (
            <div className="flex-1 flex items-center justify-center">
              <p className="text-gray-400 text-lg">No photos taken yet</p>
            </div>
          )}

          <WarehouseButtonsFooter>
            <WarehouseButton variant="default" onClick={onClose}>
              Back
            </WarehouseButton>
          </WarehouseButtonsFooter>
        </div>
      </FullscreenModal>
    </>,
    document.body
  );
};
